import React from 'react';

/**
 * Reusable action button component with consistent styling
 */
const ActionButton = ({ 
    label, 
    onClick, 
    variant = 'primary', 
    size = 'sm',
    disabled = false,
    style = {}
}) => {
    const baseStyle = {
        border: 'none',
        padding: size === 'sm' ? '6px 12px' : '8px 16px',
        borderRadius: '4px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: size === 'sm' ? '12px' : '14px',
        fontWeight: 'bold',
        ...style
    };

    const variantStyles = {
        primary: {
            backgroundColor: disabled ? '#6c757d' : '#007bff',
            color: 'white',
            onHover: disabled ? '#6c757d' : '#0056b3'
        },
        success: {
            backgroundColor: disabled ? '#6c757d' : '#28a745',
            color: 'white',
            onHover: disabled ? '#6c757d' : '#218838'
        },
        info: {
            backgroundColor: disabled ? '#6c757d' : '#17a2b8',
            color: 'white',
            onHover: disabled ? '#6c757d' : '#138496'
        },
        secondary: {
            backgroundColor: disabled ? '#6c757d' : '#6c757d',
            color: 'white',
            onHover: disabled ? '#6c757d' : '#5a6268'
        }
    };

    const variantStyle = variantStyles[variant] || variantStyles.primary;

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            style={{
                ...baseStyle,
                backgroundColor: variantStyle.backgroundColor,
                color: variantStyle.color
            }}
            onMouseOver={(e) => {
                if (!disabled) {
                    e.target.style.backgroundColor = variantStyle.onHover;
                }
            }}
            onMouseOut={(e) => {
                if (!disabled) {
                    e.target.style.backgroundColor = variantStyle.backgroundColor;
                }
            }}
        >
            {label}
        </button>
    );
};

export default ActionButton;

